import React, { useContext, useEffect, useState } from 'react';
import { getSubjects, getSubjectsWithIntitutionId } from '../../../actions';
import { Context } from '../../../defaults';
import { TopicsTable2 } from './TopicsTable2';
import { TopicsAdd } from './TopicsAdd';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const Topics = () => {
  const { dictionary, language } = useContext(Context);
  const [active, setActive] = useState('1');
  const [added, setAdded] = useState(false);
  const [subjects, setSubjects] = useState();

  const callback = (key) => {
    setActive(key);
    setAdded(false);
  };

  useEffect(() => {
    getSubjectsWithIntitutionId().then(({ data }) => setSubjects(data));
  }, []);

  return (
    <Tabs defaultActiveKey="1" activeKey={active} onChange={callback}>
      <TabPane tab={`${dictionary?.AddTopic[language]}`} key="1">
        <TopicsAdd subjects={subjects} setActive={setActive} setAdded={setAdded} />
      </TabPane>
      <TabPane tab={dictionary?.TopicsList[language]} key="2">
        <div style={{ marginTop: 24 }}>
          <TopicsTable2 added={added} subjects={subjects} />
        </div>
      </TabPane>
    </Tabs>
  );
};

export default Topics;
